

document.addEventListener("turbolinks:load", function() {
  var cartCheckoutButton = document.getElementById('checkout-cart-button')

  console.log("cartCheckoutButton", cartCheckoutButton)

  if (cartCheckoutButton === null) { return }

  cartCheckoutButton.addEventListener('click', function() {
    console.log("cartCheckoutButton", "click")

    const token = document.querySelector('meta[name="csrf-token"]').content

    console.log("url", '/cart-checkout-session')

    fetch('/cart-checkout-session', {
      method: 'POST',
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json"
      }
    })
    .then(function(response) {
      return response.json()
    })
    .then(function(session) {
      var stripe = Stripe(STRIPE_PUBLISHABLE_KEY)
      return stripe.redirectToCheckout({ sessionId: session.id })
    })
    .then(function(result) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your
      // customer using `error.message`.
      if (result.error) {
        alert(result.error.message)
      }
    })
    .catch(function(error) {
      console.error('Error:', error)
    })
  })
})


document.addEventListener("turbolinks:load", function() {
  function cartQuantity() {
    console.log("cartQuantity", this.value)

    var recordId = this.getAttribute("record")

    const token = document.querySelector('meta[name="csrf-token"]').content

    console.log("token", token)
    console.log("recordId", recordId)

    fetch('/set-quantity?item_id='+recordId+'&quantity='+this.value, {
      method: 'POST',
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json"
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      console.log("response", response)

      Turbolinks.visit(location.toString());
    })
    .then(function(result) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your
      // customer using `error.message`.
      if (result.error) {
        alert(result.error.message);
      }
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }

  var quantityChangers = document.getElementsByClassName("cart-quantity")

  for (var i = quantityChangers.length - 1; i >= 0; i--) {
    quantityChangers[i].onchange = cartQuantity
  }
})
